import React from "react";

import "./RangeInput.css";

import DebounceInput from "react-debounce-input";

const RangeInput = ({ min, max, step, value, handleOnChange }) => {
  return (
    <div className="input__container input__container--range">
      <div className="input__minus">-</div>
      <DebounceInput
        className="input input--range"
        type="range"
        debounceTimeout={500}
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={handleOnChange}
      />
      <div className="input__plus">+</div>
    </div>
  );
};

export default RangeInput;
